import '../stylesheets/base';
import '../stylesheets/tailwind.css';

require('bootstrap-sass/assets/javascripts/bootstrap');
require('vendor/assets/components/jquery-ujs/src/rails');

// Vendor libs
require('js/application');
require('validate');
require('../../../gems/lp_analytics/lib/assets/javascripts/lp_analytics');
require('data_link_api');
require('vendor/assets/javascripts/bootstrap3-typeahead');
require('vendor/assets/components/jquery.cookie/jquery.cookie');
require('js/posthog_init');

// Local libs
require('html5_support');
require('popovers');
require('remote_helper');
require('notification_helper');
require('modal_confirm');
require('abilities_helper');
require('share_buttons');
require('toggle_class');
require('ratings');
require('login_modal');
require('modal_trigger');
require('modal_hooks');
require('lp_headroom');
require('ios_fix');
require('dropdowns');
require('freemium/free_members');
require('freemium/freemium_welcome_modal');
require('signup_modal');

// App libs
require('js/header');
require('common_core_info');
require('searches');
require('directory/term_suggestions');
require('directories');
require('resources');
require('shared_collections');
require('resource/directory');
require('ss_nodes');
require('articles');
require('my/saved_searches');
require('us');
require('newsletter_form');

require('js/on_page_ready');
